import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { track, EVENTS } from "@/lib/analytics";

export default function FAQAccordion({ items, defaultOpen = 0, prefix = "faq" }) {
    const [openIdx, setOpenIdx] = useState(defaultOpen);
    return (
        <div className="space-y-3" data-testid={`${prefix}-accordion`}>
            {items.map((item, idx) => {
                const isOpen = idx === openIdx;
                return (
                    <div
                        key={idx}
                        className="rounded-lg border transition-shadow"
                        style={{
                            background: "var(--color-bg-card)",
                            borderColor: isOpen ? "var(--color-accent)" : "var(--color-line)",
                            boxShadow: isOpen ? "var(--shadow-md)" : "var(--shadow-sm)",
                        }}
                    >
                        <button
                            type="button"
                            onClick={() => {
                                const next = isOpen ? -1 : idx;
                                setOpenIdx(next);
                                track(EVENTS.FAQ_INTERACTION, { question: item.q, opened: !isOpen });
                            }}
                            className="w-full flex justify-between items-center text-left px-5 py-4 font-semibold gap-4"
                            aria-expanded={isOpen}
                            data-testid={`${prefix}-q-${idx}`}
                        >
                            <span
                                className="serif text-base md:text-lg pr-3 leading-snug"
                                style={{ color: "var(--color-text)" }}
                            >
                                {item.q}
                            </span>
                            <span
                                className="shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-all"
                                style={{
                                    background: isOpen
                                        ? "var(--color-accent)"
                                        : "rgba(40, 216, 224, 0.12)",
                                    color: isOpen
                                        ? "var(--color-cta-ink)"
                                        : "var(--color-accent)",
                                }}
                            >
                                <ChevronDown
                                    size={18}
                                    className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
                                />
                            </span>
                        </button>
                        {isOpen ? (
                            <div
                                className="px-5 pb-5 text-[15.5px] leading-relaxed"
                                style={{ color: "var(--color-text-muted)" }}
                                data-testid={`${prefix}-a-${idx}`}
                            >
                                {item.a}
                            </div>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
}
